import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "reactstrap";
import AdrEquipmentSetRowV3 from "./AdrEquipmentSetRowV3";
import { getEquipDropdownOption, sortOptionsByLabel, MAX_COLUMNS } from "./utils/adrUtilsV3";
import { getProjContractorOptions } from "../../_helpers/contractorOptions";
import adrActions from "../../_actions/adrActions";
import { ADR_EDIT } from "../../_constants/actionConstants";
import memoizeOne from "memoize-one";

class AdrEquipmentSetV3 extends Component {
  state = {
    /** @type {number[]} */
    equipmentIdsToDisable: [],
    sectionIsOpen: true,
  };

  componentDidMount() {
    const { equipmentSetClient } = this.props;

    if (equipmentSetClient)
      this.setState({ equipmentIdsToDisable: this.getEquipmentIdsToDisable() });

    this.addPlaceholderRowsIfEmpty();
  }

  componentDidUpdate(prevProps, prevState) {
    const { equipmentSetClient } = this.props;
    this.addPlaceholderRowsIfEmpty();

    if (!prevProps.equipmentSetClient && equipmentSetClient)
      this.setState({ equipmentIdsToDisable: this.getEquipmentIdsToDisable() });
  }

  addPlaceholderRowsIfEmpty = () => {
    const { dispatch, tabId, equipmentSetClient } = this.props;
    if (equipmentSetClient && Object.keys(equipmentSetClient).length === 0) {
      dispatch({ type: ADR_EDIT.EQUIPMENTSET.ADD, tabId, rowsToAdd: 4 });
    }
  };

  /**
   * Sets equipmentIds to disable from dropdown, in the component state.
   * @param {?number} equipIdToDisable - Optional, if no id is provided, rebuild the array
   *                                     from redux state.
   */
  getEquipmentIdsToDisable = (equipIdToDisable = null) => {
    const { equipmentSetClient } = this.props;
    return equipIdToDisable
      ? Array.from(new Set([...this.state.equipmentIdsToDisable, equipIdToDisable]))
      : equipmentSetClient
      ? Object.values(equipmentSetClient).map((esrClient) => esrClient.equipmentId)
      : [];
  };

  updateEquipmentIdsToDisable = (equipIdToDisable = null) =>
    this.setState({
      equipmentIdsToDisable: this.getEquipmentIdsToDisable(equipIdToDisable),
    });

  showAllOvertimeRows = (e) => {
    e.preventDefault();
    const { dispatch, tabId } = this.props;
    dispatch({ type: ADR_EDIT.EQUIPMENTSET.SHOW_ALL_OT, tabId });
  };

  hideAllOvertimeRows = (e) => {
    e.preventDefault();
    const { dispatch, tabId } = this.props;
    dispatch({ type: ADR_EDIT.EQUIPMENTSET.HIDE_ALL_OT, tabId });
  };

  toggleSection = (e) => {
    e.preventDefault();
    this.setState({ sectionIsOpen: !this.state.sectionIsOpen });
  };

  handleClick_addRow = (e) => {
    e.preventDefault();
    const { dispatch, tabId, markAdrDirty } = this.props;
    dispatch({ type: ADR_EDIT.EQUIPMENTSET.ADD, tabId });
    markAdrDirty();
  };

  handleClick_editOperators = (e) => {
    e.preventDefault();
    this.toggleEditOperatorsModal();
  };

  handleDragEnd = (result) => {
    const { dispatch, tabId, equipmentSetOrder, markAdrDirty } = this.props;
    const { destination, source, draggableId } = result;
    if (!destination) return;
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    )
      return;

    const newEso = Array.from(equipmentSetOrder);
    newEso.splice(source.index, 1); // Delete source index
    newEso.splice(destination.index, 0, draggableId); // Insert draggableId at destination index

    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.REORDER,
      tabId,
      newEquipmentSetOrder: newEso,
    });
    markAdrDirty();
  };

  /**
   * Renders header row 1. Called by renderEquipmentHeader(), where wpSortOrder
   * is defaulted to [] if null (so no null-check for this is necessary here.)
   * @param {import("../../_typedefs/adrV3TypeDefs").WpSortOrder[]} wpSortOrder
   */
  renderEquipmentHoursHeader1 = (wpSortOrder) => {
    const { workPerformedClient: wpc } = this.props;
    let col = 0;
    let ehh1 = [];

    for (col = 0; col < wpSortOrder.length; col++) {
      if (wpc[wpSortOrder[col].wpTabId].isIdle) {
        ehh1.push(
          <div key={`th1_equip_hours_${col}`} className="th-equip-hours table-warning">
            <span className="badge badge-danger">Idle</span>
          </div>
        );
      } else {
        ehh1.push(<div key={`th1_equip_hours_${col}`} className="th-equip-hours"></div>);
      }
    }

    if (col < MAX_COLUMNS) {
      for (let remCol = wpSortOrder.length; remCol < MAX_COLUMNS; remCol++) {
        ehh1.push(
          <div key={`th1_equip_hours_${remCol}`} className="th-equip-hours"></div>
        );
      }
    }

    return ehh1;
  };

  renderEquipmentHoursHeader2 = (wpSortOrder) => {
    const { workPerformedClient: wpc } = this.props;
    let col = 0;
    let ehh2 = [];

    // Equipment hours
    for (col = 0; col < wpSortOrder.length; col++) {
      if (wpc[wpSortOrder[col].wpTabId].isIdle) {
        ehh2.push(
          <div
            key={`th2_equip_hours_${col}`}
            className="labor-equip-padding labor-equip-th th-equip-hours table-warning"
          >
            <span>{wpc[wpSortOrder[col].wpTabId].wpShortCaption}</span>
          </div>
        );
      } else {
        ehh2.push(
          <div
            key={`th2_equip_hours_${col}`}
            className="labor-equip-padding labor-equip-th th-equip-hours th-container"
          >
            <span className="th-align-center">
              {wpc[wpSortOrder[col].wpTabId].wpShortCaption}
            </span>
          </div>
        );
      }
    }

    if (col < MAX_COLUMNS) {
      for (let remCol = wpSortOrder.length; remCol < MAX_COLUMNS; remCol++) {
        ehh2.push(<div key={`th2_equip_hours_${remCol}`} className="th-equip-hours" />);
      }
    }

    return ehh2;
  };

  /**
   * Renders equipment table header. There are two header rows - first row is mostly
   * blank, used for Idle flag only, and second row displays all the column
   * headers for both static (Contractor, Number/Desc, etc.) and dynamic (item or CCO
   * numbers, from wpShortCaption) content.
   * @param {import("../../_typedefs/adrV3TypeDefs").WpSortOrder[]} wpSortOrder - an empty array if there are no Wp's
   */
  renderEquipmentHeader = (wpSortOrder = []) => {
    const h1 = (
      <div key="th1-equip" className="d-flex flex-row flex-wrap es-table">
        <div
          key="th1_equip_draghandle"
          className="labor-equip-padding th-equip-draghandle"
        ></div>
        <div
          key="th1_equip_contractor"
          className="labor-equip-padding th-equip-contractor"
        ></div>
        <div
          key="th1_equip_name"
          className="labor-equip-padding th-equip-number-desc"
        ></div>
        <div key="th1_equip_add" className="labor-equip-padding th-equip-add"></div>
        <div
          key="th1_equip_time_type"
          className="labor-equip-padding th-equip-time-type"
        ></div>
        {this.renderEquipmentHoursHeader1(wpSortOrder || [])}
        <div key="th1_equip_op" className="th-equip-operator"></div>
        <div key="th1_equip_dropdown" className="th-equip-dropdown"></div>
        <div key="th1_equip_delete" className="th-equip-delete"></div>
      </div>
    );

    const h2 = (
      <div key="th2-equip" className="d-flex flex-row flex-wrap es-table">
        <div
          key="th2_equip_draghandle"
          className="labor-equip-padding th-equip-draghandle"
        ></div>
        <div
          key="th2_equip_contractor"
          className="labor-equip-padding labor-equip-th th-equip-contractor th-container"
        >
          <span>Contractor</span>
        </div>
        <div
          key="th2_equip_name"
          className="labor-equip-padding labor-equip-th th-equip-number-desc th-container"
        >
          <span>(Number) Class / Make / Model Code</span>
        </div>
        <div key="th2_equip_add" className="labor-equip-padding th-equip-add"></div>
        <div
          key="th2_equip_time_type"
          className="labor-equip-padding th-equip-time-type"
        ></div>
        {this.renderEquipmentHoursHeader2(wpSortOrder || [])}
        <div
          key="th2_equip_op"
          className="labor-equip-padding labor-equip-th th-equip-operator"
        >
          <span>Oper.</span>
        </div>
        <div key="th2_equip_dropdown" className="th-equip-dropdown"></div>
        <div key="th2_equip_delete" className="th-equip-delete"></div>
      </div>
    );

    return [h1, h2];
  };

  memoizedWpSortOrder = memoizeOne((wpc) => {
    const { dispatch, tabId } = this.props;
    return wpc && Object.keys(wpc).length > 0
      ? dispatch(adrActions.getWorkPerformedSortOrder(tabId))
      : null;
  });

  memoizedEquipmentOptions = memoizeOne((projEquipList) =>
    projEquipList ? sortOptionsByLabel(projEquipList.map(getEquipDropdownOption)) : null
  );

  // getProjContractorOptions already orders Prime first, then subs/suppliers
  // alphabetically — don't re-sort by label, it would push Prime out of first
  // place based on where "(P)" happens to fall alphabetically.
  memoizedContractorOptions = memoizeOne((projContractorList) =>
    projContractorList ? getProjContractorOptions(projContractorList) : null
  );

  render() {
    const {
      projectId,
      tabId,
      projContractorList,
      projEquipList,
      equipmentSetClient,
      equipmentSetOrder,
      workPerformedClient: wpc,
      status,
      fetching,
      markAdrDirty,
    } = this.props;
    const { sectionIsOpen, equipmentIdsToDisable } = this.state;

    /** @type {import("../../_typedefs/adrV3TypeDefs").WpSortOrder} */
    const wpSortOrder = this.memoizedWpSortOrder(wpc);

    /** @type {SelectOption[]} */
    const contractorOptions = this.memoizedContractorOptions(projContractorList);
    /** @type {SelectOption[]} */
    const equipmentOptions = this.memoizedEquipmentOptions(projEquipList);

    return (
      <React.Fragment>
        <div className="card m-2">
          <div className="card-body e-parent">
            <p className="h3">
              <span onClick={this.toggleSection} className="pointer-cursor">
                {sectionIsOpen ? (
                  <FontAwesomeIcon icon="caret-down" className="fa-fw mr-2" />
                ) : (
                  <FontAwesomeIcon icon="caret-right" className="fa-fw mr-2" />
                )}
                Equipment
              </span>
            </p>
            <Collapse isOpen={sectionIsOpen}>
              <div className="d-flex flex-column es-parent">
                {this.renderEquipmentHeader(wpSortOrder)}
                <DragDropContext onDragEnd={this.handleDragEnd}>
                  <Droppable droppableId="equipmentSetClient">
                    {(provided) => (
                      <div
                        className="es-table"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {equipmentSetOrder &&
                          equipmentSetOrder.map((rowKey, index) => (
                            <AdrEquipmentSetRowV3
                              key={rowKey}
                              rowKey={rowKey}
                              rowIndex={index}
                              projectId={projectId}
                              tabId={tabId}
                              wpSortOrder={wpSortOrder}
                              equipmentSetRow={equipmentSetClient[rowKey]}
                              contractorOptions={contractorOptions}
                              equipmentOptions={equipmentOptions}
                              equipmentIdsToDisable={equipmentIdsToDisable}
                              updateEquipmentIdsToDisable={
                                this.updateEquipmentIdsToDisable
                              }
                              status={status}
                              fetching={fetching}
                              markAdrDirty={markAdrDirty}
                            />
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
              <div className="d-flex flex-row mt-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="addEquipWpr"
                  name="addEquipWpr"
                  onClick={this.handleClick_addRow}
                  disabled={status.isReadOnly}
                >
                  <FontAwesomeIcon icon="stream" className="fa-fw mr-2" />
                  Add New Row
                </button>
                <div className="card ml-4">
                  <div className="card-body p-1 d-flex flex-row">
                    <div className="ml-2 my-auto align-middle">
                      <b>Overtime:</b>
                    </div>
                    <button
                      type="button"
                      id="showAllOtRows"
                      name="showAllOtRows"
                      className="btn btn-sm btn-outline-info ml-2"
                      onClick={this.showAllOvertimeRows}
                    >
                      Show All
                    </button>
                    <button
                      type="button"
                      id="hideAllOtRows"
                      name="hideAllOtRows"
                      className="btn btn-sm btn-outline-info ml-2"
                      onClick={this.hideAllOvertimeRows}
                    >
                      {`Show >0 Only`}
                    </button>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  projEquipList: state.equipment.projEquipLists[ownProps.projectId] || null,
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
  equipmentSetClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].equipmentSetClient || null
    : null,
  equipmentSetOrder: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].equipmentSetOrder || []
    : null,
});

export default connect(mapStateToProps)(AdrEquipmentSetV3);
